"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Decision = exports.SuspensionReason = void 0;
var SuspensionReason;
(function (SuspensionReason) {
    SuspensionReason["ROAD_SAFETY"] = "ROAD_SAFETY";
    SuspensionReason["BEHAVIOR"] = "BEHAVIOR";
    SuspensionReason["TRIP_MANAGEMENT"] = "TRIP_MANAGEMENT";
    SuspensionReason["QUALITY_OF_SERVICE"] = "QUALITY_OF_SERVICE";
    SuspensionReason["COMPLIANCE"] = "COMPLIANCE";
})(SuspensionReason = exports.SuspensionReason || (exports.SuspensionReason = {}));
var Decision;
(function (Decision) {
    Decision["SUSPENDED"] = "SUSPENDED";
    Decision["BLACKLISTED"] = "BLACKLISTED";
    Decision["NOTHING"] = "NOTHING";
})(Decision = exports.Decision || (exports.Decision = {}));
